if (!customElements.get('halloween-perks-marquee')) {
  customElements.define('halloween-perks-marquee', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.halloween-perks__track');
      this.list = this.querySelector('.halloween-perks__list');
      if (!this.list || !this.list.children.length) return;

      this.clone = this.track.querySelector('[aria-hidden="true"]');
      if (!this.clone) {
        this.clone = this.list.cloneNode(true);
        this.clone.setAttribute('aria-hidden', 'true');
        this.clone.querySelectorAll('[data-shopify-editor-block]').forEach((item) => item.removeAttribute('data-shopify-editor-block'));
        this.clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        this.track.append(this.clone);
      }

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('pointerdown', () => this.classList.add('is-pressed'), options);
      const release = () => this.classList.remove('is-pressed');
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.addEventListener('shopify:block:select', () => this.classList.add('is-selected'), options);
      this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-selected'), options);

      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this);
      this.observer.observe(this.list);
      this.update();
    }

    update() {
      const viewportWidth = this.clientWidth;
      if (!viewportWidth) return;
      this.classList.add('is-ready');
      this.track.style.setProperty('--perks-viewport-width', `${viewportWidth}px`);
      const textWidth = [...this.list.children].reduce((sum, item) => sum + item.getBoundingClientRect().width, 0);
      const gap = Math.max(48, (viewportWidth - textWidth) / this.list.children.length);
      this.track.style.setProperty('--perks-gap', `${gap}px`);
      const distance = this.list.getBoundingClientRect().width;
      this.track.style.setProperty('--perks-distance', `${distance}px`);
      // A constant pixel speed keeps long copy and small screens equally readable.
      this.track.style.setProperty('--perks-duration', `${distance / 26}s`);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.classList.remove('is-pressed', 'is-selected');
    }
  });
}
